import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsCurrencyDollar } from "react-icons/bs";
import AuditionIncomeCard from "../Reuse/AuditionIncomeCard";

function AuditionAllIncome() {
  const [auditionIncome, setAuditionIncome] = useState();
  useEffect(() => {
    axios.get("/api/audition-admin/dashboard/total-income").then((res) => {
      if (res.data.status === 200) {
        
        setAuditionIncome(res.data.auditionIncome);
      }
    });
  }, []);
  return (
    <>
      <div className="row">
        <AuditionIncomeCard
          title={"Total"}
          amount={auditionIncome?.auditionTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />

        <AuditionIncomeCard
          title={"Daily"}
          amount={auditionIncome?.auditionDailyIncome}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />

        <AuditionIncomeCard
          title={"Weekly"}
          amount={auditionIncome?.auditionWeeklyIncome}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />

        <AuditionIncomeCard
          title={"Monthly"}
          amount={auditionIncome?.auditionMonthlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />

        <AuditionIncomeCard
          title={"Yearly"}
          amount={auditionIncome?.auditionYearlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />
      </div>
    </>
  );
}

export default AuditionAllIncome;
